import { render } from "./ShiftForm.vue?vue&type=template&id=bf1e368c&scoped=true"
import script from "./ShiftForm.vue?vue&type=script&lang=js"
export * from "./ShiftForm.vue?vue&type=script&lang=js"

import "./ShiftForm.vue?vue&type=style&index=0&id=bf1e368c&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1e368c"]])

export default __exports__